export default __webpack_public_path__ + "static/media/3WL10.2ad6d517.jpg";